import { useState, useCallback } from 'react'
import SettingsChips2 from './SettingsChips/SettingsChips2'
import SettingsChips3 from './SettingsChips/SettingsChips3'
import { Button, Message, Row } from '@iqueue/ui-kit'
import SettingsPresenter from '../../api/SettingsPresenter'
import { t } from '../../hooks/useTranslate'

export default function SettingsChipsContainer() {
  const [tableChipsSeed, setTableChipsSeed] = useState([])
  const [tableChipsOrder, setTableChipsOrder] = useState([])

  const handleSaveChipsSeed = useCallback(() => {
    SettingsPresenter.post('seed-tables', {
      tables: tableChipsSeed,
    }).then(() => {
      Message({
        type: 'success',
        timeout: 3000,
        title: t('settingsPage.messages.requestSuccess'),
      })
    }).catch(err => console.log(err))
  }, [tableChipsSeed])

  const handleSaveChipsOrder = useCallback(() => {
    SettingsPresenter.post('tables-order', {
      order: tableChipsOrder,
    }).then(() => {
      Message({
        type: 'success',
        timeout: 3000,
        title: t('settingsPage.messages.requestSuccess'),
      })
    }).catch(err => console.log(err))
  }, [tableChipsOrder])

  return <div>
    <div className={ 'main-chips-button' }>
      <SettingsChips2 chips={ tableChipsSeed } onChange={ setTableChipsSeed }/>
      <Row>
        <Button
          secondary
          size={ 12 }
          title={ t('settingsPage.chips.save') }
          onClick={ handleSaveChipsSeed }
        />
      </Row>
    </div>
    <div className={ 'main-chips-button' }>
      <SettingsChips3 chips={ tableChipsOrder } onChange={ setTableChipsOrder }/>
      <Row>
        <Button
          size={ 12 }
          secondary
          title={ t('settingsPage.chips.save') }
          onClick={ handleSaveChipsOrder }
        />
      </Row>
    </div>
  </div>
}
